import { getField } from '../module/moduleComponentHelper';
import { getH2sDataColor } from './tableHelper';

export const NO_TELEMETRY_DATE_LABEL = 'Pas de télégestion !';

export interface MostRecentCategDateInfo {
  value: string;
  hasTelemetry: boolean;
}

// get date of the most recent categ calculated
export const getMostRecentCategDateInfo = (
  pData: any[],
  pModule: string,
): MostRecentCategDateInfo => {
  const dates: any[] = [];
  const moduleType = window.localStorage.getItem('type');
  let dateToShow: string = NO_TELEMETRY_DATE_LABEL;
  const colorFieldName = moduleType !== 'h2s' ? 'Color' : getH2sDataColor();
  if (pData !== undefined && pData.length !== 0) {
    // get name of outfield
    const outfield = moduleType !== 'h2s' ? getField(pModule) : 'RecordDate'+colorFieldName.slice(5);
    // get dates
    pData.forEach((line) => {
        if (
          line[outfield] &&
          line[outfield] !== null &&
          line[colorFieldName] !== 'NOIR'
        ) {
          dates.push(line[outfield]);
        }
    });
    if (dates.length !== 0) {
      // get the recent date
      dates.sort((date1, date2) => date2 - date1);
      if (pModule !== 'pluie' && pModule !== 'sensibility' && pModule !== 'dilution') {
        dateToShow = new Date(dates[0]).toLocaleDateString('fr');
      } else {
        const date = new Date(dates[0]);
        const month = date.toLocaleString('fr-FR', { month: 'long' });
        const year = date.getFullYear().toString();
        dateToShow =
        pModule === 'pluie' ? (month.charAt(0).toUpperCase() + month.slice(1) + ' ' + year) : year;
      }
    }
  }
  return {
    value: dateToShow,
    hasTelemetry: dates.length !== 0,
  };
};

export const getMostRecentCategDate = (pData: any[], pModule: string) => {
  return getMostRecentCategDateInfo(pData, pModule).value;
};
